import React, { useState } from 'react';
import { Modal, Form, InputNumber, Alert, message, Button } from 'antd';
import { getCurrentShopId } from '../pages/shop/get-current-shop';

const Withdraw = ({ maxAmount, children, type, ...others }) => {
    const [visible, setVisible] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const showModal = () => {
        setVisible(true);
    };

    const handleOk = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            const shopId = await getCurrentShopId();

            let url = '';

            if(type === 'order') {
                url = '/api/finance/pay-out';
            } else if(type === 'invite') {
                url = '/api/finance/pay-out-invite';
            }
            
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shopId,
                    amount: values.amount
                })
            });
            
            const result = await res.json();
            if (result && result.success) {
                message.success('提现成功，请等待到账(2-5个工作日)');
                form.resetFields();
                setVisible(false);
            } else {
                message.error(result.data || '提现失败');
            }
        } catch (error) {
            message.error('提现失败');
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setVisible(false);
        form.resetFields();
    };

    return (
        <>
            <Button 
                {...others}
                type='primary'
                onClick={showModal}
            >
                提现
            </Button>
            <Modal 
                title="提现" 
                open={visible} 
                onOk={handleOk} 
                onCancel={handleCancel}
                okText="提现" 
                cancelText="取消"
                okButtonProps={{ loading }}
                destroyOnClose={true}
            >
                <Form form={form} layout="vertical" name="withdraw_form">
                    <Form.Item 
                        label={`提现金额`} 
                        name="amount" 
                        rules={[
                            { required: true, message: '请输入提现金额' },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || value <= maxAmount) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error(`可提现金额为${maxAmount}元`));
                                },
                            }),
                        ]}
                        style={{ width: '100%' }}
                    >
                        <InputNumber 
                            min={0} 
                            max={maxAmount} 
                            autoFocus 
                            style={{ width: '100%' }} 
                            placeholder={`可提现${maxAmount || 0}元`} 
                        />
                    </Form.Item>
                    <Alert message="资金提现后将在5个工作日内到账" type="info" />
                </Form>
            </Modal>
        </>
    );
};

export default Withdraw;